import {Component, Input, OnInit} from '@angular/core';
import {TemplateComponent} from "../../template/template.component";
import {NgIf} from "@angular/common";

@Component({
    selector: 'app-story-list-item',
    standalone: true,
    imports: [
        NgIf
    ],
    templateUrl: './story-list-item.component.html',
    styleUrl: './story-list-item.component.css'
})
export class StoryListItemComponent extends TemplateComponent implements OnInit{
    @Input() bgColor: string = "#ffffff";
    @Input() text: string = "";
    @Input() logoSrc: string = "";
    @Input() imgSrc: string="";
    @Input() uid: string="";
    @Input() pageType="SUCCESS_STORY";


    ngOnInit() {

    }

    goToSuccessPage(pageuid: String) {
        if(this.pageType=="SUCCESS_STORY"){
            this.route.navigate(["/success_story/"+pageuid])
        }else if(this.pageType=="PAGE"){
            this.route.navigate(["/page/"+pageuid])
        }else if(this.pageType=="PAGE"){
            this.route.navigate(["/page/"+pageuid])
        }

    }
}
